'use client';

import {
  type BaseArtifactDto,
  BrowserRecordingArtifactMetadataSchema,
} from '@terra/shared-contracts-artifact';
import { useArtifactsOptional } from '../ArtifactsProvider';
import { useBrowserToolCallArtifact } from './useBrowserToolCallArtifact';

const pickRecordingArtifact = (
  artifacts: BaseArtifactDto[],
): BaseArtifactDto | null =>
  artifacts.find(
    (artifact) =>
      BrowserRecordingArtifactMetadataSchema.safeParse(artifact.metadata)
        .success,
  ) ?? null;

export const useRecordingArtifact = (
  toolCallId: string,
): BaseArtifactDto | null => {
  const artifactFromTrace =
    useArtifactsOptional()?.getRecordingByToolCallId(toolCallId) ?? null;
  const fetchedArtifact = useBrowserToolCallArtifact({
    toolCallId,
    enabled: !artifactFromTrace,
    pick: pickRecordingArtifact,
  });

  return artifactFromTrace ?? fetchedArtifact;
};
